<template>
    <div class="ani-group-list-container">
        <div class="header">
            <div class="filters mb-3">
                <div class="field">
                    <search-input
                            placeholder="Search for ANI Group Name"
                            v-model="filters.ani_group_name"
                    />
                </div>
            </div>
            <div class="buttons flex-wrap">
                <div
                        @click="is_show_add_row = true"
                        class="primary-button smsc-btn mb-3"
                >
                    <primary-button>Add ANI Group</primary-button>
                </div>
                <div
                        @click="$router.push({name: 'system-admin-ani-group-import'})"
                        class="primary-button smsc-btn mb-3 "
                >
                    <primary-button>Import Number</primary-button>
                </div>
            </div>
        </div>
        <loader :loading="loading" v-if="loading"/>
        <template v-else>
            <not-found v-if="!isFound"/>
            <div v-else class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
                <table class="Invoice_table">
                    <thead>
                    <tr class="Invoice_table_header">
                        <th>ANI Group</th>
                        <th width="140">Public</th>
                        <th>Last Updated</th>
                        <th>Updated By</th>
                        <th># of TN</th>
                        <th>User By Count</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                            v-if="is_show_add_row"
                            class="add-row"
                    >
                        <th>
                            <primary-input
                                    name="ani group name"
                                    v-model="add.ani_group_name"
                                    v-validate="'required'"
                                    :class="{ input: true, 'is-danger': errors.has('ani group name') }"
                                    class="no-showing-name"
                                    placeholder="Enter name"
                            />
                        </th>
                        <th>
                            <primary-select
                                    v-model="add.is_public"
                                    :options="is_public_opt"
                            />
                        </th>
                        <th colspan="3"></th>
                        <th colspan="2">
                            <div class="action-buttons">
                                <div class="smsc-btn" @click="AddAniGroup">
                                    <primary-button>Save</primary-button>
                                </div>
                                <div class="smsc-btn" @click="CloseAddRow">
                                    <secondary-button>Cancel</secondary-button>
                                </div>
                            </div>
                        </th>
                    </tr>
                    <tr v-for="(ani, i) in anis" :key="i">
                        <th class="editable">
                            <primary-input
                                    :value="ani.ani_group_name"
                                    :disabled="!ani.is_edit"
                                    @input="editing_ani.ani_group_name = $event"
                            />
                        </th>
                        <th class="editable">
<!--                            <primary-select-->
<!--                                    type="text"-->
<!--                                    :options="is_public_opt"-->
<!--                                    :value="ani.is_public"-->
<!--                                    @input="editing_ani.is_public = $event"-->
<!--                                    :class="{'disabled': !ani.is_edit}"-->
<!--                                    :disabled="!ani.is_edit"-->
<!--                            />-->
                            <span>{{ani.is_public}}</span>
                        </th>
                        <th>{{ moment(ani.updated_on).format('YYYY-MM-DD') }}</th>
                        <th>{{ ani.updated_by }}</th>
                        <th>{{ ani.count_of_tns }}</th>
                        <th>{{ ani.count_of_users }}</th>
                        <th class="action">
                            <div class="actions">
                                <div
                                        v-if="ani.is_edit"
                                        @click="Editing(!ani.is_edit, ani.ani_group_uuid)"
                                        class="save-btn"
                                        title="Save"
                                >
                                        <save-icon size="1.8x" class="custom-class mx-1"></save-icon>
                                </div>
                                <svg
                                        v-else
                                        @click="Editing(!ani.is_edit, ani.ani_group_uuid)"
                                        class="svg-grey"
                                        width="35px"
                                        height="35px"
                                        viewBox="0 0 30 30"
                                        version="1.1"
                                >
                                    <title>Edit</title>
                                    <path
                                            d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                                            id="path-1"
                                    />
                                </svg>
                                <svg
                                        @click="deleteProduct(ani.ani_group_uuid)"
                                        class="svg-grey delete"
                                        width="35px"
                                        height="35px"
                                        viewBox="0 0 30 30"
                                        version="1.1"
                                >
                                    <title>Delete</title>
                                    <path
                                            d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                                            id="path-1"
                                    />
                                </svg>

                                <div title="Numbers">
                                    <router-link tag="div"
                                            :to="{ name: 'system-admin-ani-group-numbers', params: { uuid : ani.ani_group_uuid } }">
                                        <grid-icon size="1.8x" class="custom-class mx-1"></grid-icon>
                                    </router-link>
                                </div>
                            </div>
                        </th>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col col-lg-7 col-md-7 col-xs-12 per-page">
                <span class="filter_by">Show Per Page:</span>
                <div class="primary-input-container choose-type perPage">
                    <primary-select
                            type="text"
                            @input="changePerPage"
                            v-model="per_page" :is-cross="false"
                            class="choose-type perPage"
                            placeholder="Select"
                    >
                        <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
                    </primary-select>
                </div>
            </div>
            <div class="buttons-wrapper">
                <pagination-component
                        @change-page="changePage($event)"
                        :page="Page"
                        :total="totalPage"
                        :perPage="per_page"
                        :qnt="anis.length"
                />
            </div>
        </template>
    </div>
</template>

<script>
    import moment from 'moment'
    import { GridIcon, SaveIcon  } from 'vue-feather-icons'

    export default {
        components: {
            SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
            SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
            PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
            PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
            PaginationComponent: () => import("@/components/Pagination.vue"),
            A11yDialog: () => import("@/components/A11yDialog.vue"),
            Loader: () => import("@/components/Loader.vue"),
            NotFound: () => import("@/components/NotFound.vue"),
            GridIcon,
            SaveIcon
        },
        data: () => ({
            moment,
            rate_table: [],
            rates: [],
            routing: [],
            vendor_product: [],
            vendor_rates: [],
            is_public_opt: [
                {name: 'True', value: true},
                {name: 'False', value: false}
            ],
            dialog: null,
            rate_table_uuid: null,
            routing_uuid: null,
            filters: {
                ani_group_name: ''
            },
            anis: [],
            Page: 0,
            pages: [10, 50, 100],
            per_page: 10,
            totalPage: 0,
            isFound: false,
            loading: true,
            filter_timeout: null,
            is_show_add_row: false,
            add: {
                ani_group_name: null,
                is_public: false
            },
            editing_ani: {
                ani_group_name: null,
                is_public: null,
            }
        }),
        created() {
            this.GetList();
        },
        watch: {
            'filters.ani_group_name': function (r) {
                clearTimeout(this.filter_timeout)

                this.filter_timeout = setTimeout(() => {
                    this.GetList()
                }, 800)
            }
        },
        methods: {
            changePerPage(e) {
                this.Page = 0;
                this.GetList();
            },
            changePage(page) {
                this.Page = page;
                this.GetList();
            },
            // transform data functions
            transformAniList(item) {
                return {
                    ani_group_name: item.ani_group_name,
                    ani_group_uuid: item.ani_group_uuid,
                    is_public: item.is_public,
                    updated_on: item.updated_on,
                    updated_by: item.updated_by,
                    count_of_tns: item.count_of_tns,
                    count_of_users: item.count_of_users,
                    is_edit: false
                };
            },

            // getting ANI list
            GetList() {
                this.loading = true;
                this.isFound = false;
                this.$store
                    .dispatch("GetAniList", {
                        page: this.Page || 0,
                        per_page: this.per_page || 10,
                        ani_group_name: this.filters.ani_group_name

                    })
                    .then((res) => {
                        this.loading = false;
                        if (!res.items.length) {
                            this.isFound = false;
                            return;
                        }
                        this.isFound = true;
                        this.anis = res.items.map(this.transformAniList);
                        this.totalPage = res.total / res.per_page;
                    })
                    .catch((err) => this.$error(err));
            },
            CloseAddRow() {
                this.is_show_add_row = false
                this.add.ani_group_name = ''
                this.add.is_public = false
            },
            AddAniGroup() {
                this.$validator.validate().then((result) => {
                    if (result) {
                        this.$store.dispatch('AddAniGroup', {
                            ani_group_name: this.add.ani_group_name,
                            is_public: this.add.is_public
                        })
                            .then(res => {
                                this.$snotify.success('ANI Group has been added', {timeout: 6000})
                                this.CloseAddRow()
                                this.GetList()
                            })
                    }
                })
            },
            Editing(is_edit, id) {
                let finded;
                this.anis.forEach(ani => {
                    if (ani.ani_group_uuid === id) {
                        finded = ani
                        ani.is_edit = is_edit
                    } else {
                        ani.is_edit = false
                    }
                })

                if (is_edit) {
                    // Editing ============================================================
                    this.editing_ani.ani_group_name = finded.ani_group_name
                    this.editing_ani.is_public = finded.is_public

                } else {
                    // Call API ===========================================================
                    this.loading = true
                    this.$store.dispatch("EditAniGroup", {
                        id,
                        aniGroup: this.editing_ani,
                    })
                        .then(res => {
                            this.GetList()
                            this.$snotify.success("ANI Group have beed edited.", {
                                timeout: 6000,
                            });
                        })
                        .catch(err => {
                            this.$snotify.error(err, {timeout: 6000});
                        })
                        .finally(() => {
                            this.loading = false
                        });
                }
            },
            deleteProduct(id) {
                this.$swal({
                    title: "Are you sure?",
                    text: "You will not be able to recover this ANI Group!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, keep it",
                }).then((result) => {
                    if (!result.value) {
                        return;
                    }
                    this.$store
                        .dispatch("DeleteAniGroup", id)
                        .then((res) => {
                            if (res.success === true) {
                                this.GetList();
                                this.$swal("Deleted!", "The ANI Group has been deleted.", "success");
                            }
                        })
                        .catch((err) => this.$error(err));
                });
            },
        },
    };
</script>

<style scoped lang="scss">
    .no-showing-name .pimary-input-title {
        display: none;
    }

    table.Invoice_table {
        .editable {
            .primary-input-container {
                margin: 0;

                input {
                    text-align: center;
                    padding-left: 0;

                    &:disabled {
                        border: none;
                        background: #fff;
                        color: #212b36;
                    }
                }

                select {
                    text-align-last: center;

                    &:disabled {
                        color: #212b36;
                        opacity: 1;
                    }
                }

                &.disabled {
                    .primary-select-wrapper {
                        border: none;

                        select {
                            text-align: center;
                            color: #212b36;
                        }

                        img {
                            display: none;
                        }
                    }
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    .custom-class {
        color: #5f6a76;
    }
    .per-page {
        display: flex;
        align-items: center;
        margin-top: 20px;
        padding: 0;
    }

    .perPage {
        width: 120px;
        display: inline-block;
    }

    span {
        margin-right: 10px;
    }

    .table_div {
        .Invoice_table {
            width: 100%;
            margin: 21px auto 0;

            th {
                text-align: center;

                &.action {
                    width: 140px;
                    height: 100%;

                    .actions {
                        display: flex;
                        justify-content: space-evenly;
                        align-items: center;
                        width: 100%;
                    }
                }
            }

            .add-row {
                th {
                    padding: 10px;

                    .action-buttons {
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;

                        .smsc-btn {
                            margin-right: 20px;

                            &:last-child {
                                margin-right: 0;
                            }
                        }
                    }
                }
            }
        }
    }

    table thead tr {
        background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
    }

    table thead th:first-child {
        padding-left: 20px;
        padding-right: 30px;
        width: 22%;
    }

    table,
    tr {
        width: 100%;
        height: 44px;
        box-shadow: inset 0 -1px 0 0 #f0f1fa;
        -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
        -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
        background-color: #ffffff;
    }

    .Invoice_table tbody tr th {
        color: #212b36;
        font-weight: normal;
        font-family: "Helvetica Neue";
        height: 20px;
        font-size: 14px;
        font-weight: normal;
        line-height: 20px;
        padding: 7px 10px 7px 20px;
        text-align: left;
    }

    table tr th {
        padding: 7px 10px 7px 0;
    }

    table {
        border-collapse: collapse;
    }

    .Invoice_table_header th {
        color: white;
        padding-left: 10px;
        border-bottom-width: 2px;
        vertical-align: bottom;
        border-bottom: 2px solid #dee2e6;
        border: 1px solid #dee2e6;
        padding: 0.75rem;
        text-align: center;
    }

    .Invoice_table_popup {
        height: 30px;
        text-align: right;
        position: relative;
        padding: 0;
        float: right;

        .popup_cta {
            cursor: pointer;
            color: #55616e;
        }
    }

    table thead th:first-child {
        padding-left: 35px;
    }

    tbody th:first-child {
        padding: 5px 10px 5px 0;

        span {
            padding: 7px 0;
        }
    }

    tbody th.created_by {
        line-height: 20px;
        height: 20px;
        padding: 7px 0 27px 0;
    }

    .svg-grey {
        fill: #55616e;
        margin-left: 3px;
    }

    div.buttons-wrapper {
        width: 100%;
        justify-content: flex-end;
    }

    @media (max-width: 600px) {
        .buttons-wrapper {
            width: 100% !important;
        }
        .col-lg-6.col-md-7.col-xs-12 {
            margin-top: 15px;
        }
    }

    .buttons-wrapper {
        display: flex;
        align-items: center;
        width: fit-content;
    }

    .perPage {
        width: 120px;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        height: auto;
        margin-bottom: 20px;

        .filters {
            display: flex;
            align-items: center;

            .field {
                width: 240px;
                margin-right: 20px;

                &:last-child {
                    margin-right: 0;
                }
            }
        }

        .buttons {
            display: flex;
            align-items: center;

            .smsc-btn {
                margin-right: 20px;

                &:last-child {
                    margin-right: 0;
                }
            }

            .primary-button {
                height: 40px;
                width: 160px;
            }
        }
    }

    .status {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        display: inline-grid;
        margin: 0 10px 0 12px;
        float: left;
    }

    .active {
        th .status {
            background-color: #24e2b8;
        }
    }

    .inactive {
        // background-color: #f0f1fa;
        th .status {
            background-color: #d2305b;
        }
    }

    .radio-button.active {
        padding: 2px 3px 3px 23px;
        background-color: #24e2b8;
        border: 0;
    }

    .radio-button {
        height: 30px;
        width: 50px;
        border-radius: 15px;
        background-color: #ffffff;
        border: 1px solid #a6b6be;
        margin-left: 10px;
        padding: 2px 23px 3px 3px;
        display: inline-block;
        margin-right: 5px;
        cursor: pointer;
    }

    th.icon .radio-button svg {
        height: 24px;
        width: 24px;
    }

    @media (max-width: 1420px) {
        .ani-group-list-container table.Invoice_table {
            width: 1320px;
        }
    }

    .table_div::-webkit-scrollbar {
        // width: 5px;
        width: 8px;
        height: 8px;
        background-color: #f5f5f5;
    }

    .table_div::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(
                        linear,
                        left bottom,
                        left top,
                        color-stop(0.44, #51a3f3),
                        color-stop(0.72, #51a3f3),
                        color-stop(0.86, #51a3f3)
        );
    }
</style>

